// extracted by mini-css-extract-plugin
export var menuIcon = "_tk-0";
export var menuIconInline = "_tk-1";